<template>
	<div class="container">
		<!-- header -->
		<div class="common-header-wrap">
			<mt-header title="اتصل بالمورد" class="common-header">
				<mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
			</mt-header>
		</div>
		<div class="body">
      <div class="product_info" v-on:click='goDetail(goods_info.goods_id)'>
<!--        <div class="product_info_t">To: Zhejiang Handinhand Electrical Technology Co., Ltd.</div>-->
        <div class="product_info_b">
          <div class="product_info_b_dt">
            <div class="product_info_b_dt_img">
              <img :src="goods_info.goods_image_url"/>
            </div>
          </div>
          <div class="product_info_b_dd">
            <div class="product_info_name">{{goods_info.goods_name}}</div>
            <div class="product_info_price" v-if="goods_info.wholesalegoods_price != ''">USD {{ goods_info.wholesalegoods_price }}/Piece</div>
            <div class="product_info_price" v-else>USD {{ goods_info.goods_price }}/Piece</div>
          </div>
        </div>
      </div>
      <div class="contact_info">
        <div class="contact_info_title">
          <h3>معلومات الاتصال</h3>
        </div>
        <div class="contact_info_form">
          <div class="contact_info_form_item">
            <input type="text" class="input_text" v-model="email" maxlength="160" placeholder="البريد الإلكتروني" autocorrect="off" autocapitalize="off" autocomplete="off">
          </div>
          <div class="contact_info_form_item">
            <input type="text" class="input_text" v-model="subject" placeholder="موضوعات" autocorrect="off" autocapitalize="off" autocomplete="off">
          </div>
          <div class="contact_info_form_item">
            <input type="text" class="input_text purchase_quantity" v-model="purchase_quantity" maxlength="160" placeholder="كمية الشراء" autocorrect="off" autocapitalize="off" autocomplete="off">
            <select v-model="purchase_quantity_type" class="input_select">
              <option class="option" value="Pieces" selected="selected">Pieces</option>
              <option class="option" value="Bags">Bags</option>
              <option class="option" value="Boxes">Boxes</option>
              <option class="option" value="Foot">Foot</option>
              <option class="option" value="Meter">Meter</option>
              <option class="option" value="Pairs">Pairs</option>
              <option class="option" value="Reams">Reams</option>
              <option class="option" value="Rolls">Rolls</option>
              <option class="option" value="Sets">Sets</option>
              <option class="option" value="Square Meters">Square Meters</option>
              <option class="option" value="Square Feet">Square Feet</option>
              <option class="option" value="Tons">Tons</option>
              <option class="option" value="Yard">Yard</option>
              <option class="option" value="Other">Other</option>
            </select>
          </div>
        </div>
      </div>
      <div class="inquiry_info">
        <div class="inquiry_info_title">
          <h3>معلومات الاستفسار</h3>
        </div>
        <div class="inquiry_info_desc">
          <textarea class="input_textarea" v-model="content" rows="3" placeholder="Hi, can you tell me more about this product? Such as price, specifications, after-sale services and so on." autocorrect="off" autocapitalize="off" autocomplete="off"></textarea>
        </div>
      </div>

      <div class="verification_info">
        <div class="verification_info_title">
          <h3>شيفرة التأكيد</h3>
        </div>
        <div class="verification_info_con">
          <mt-field v-model="pictureCode">
            <img @click="changePictureCode" height="48" :src="pictureCodeUrl" class="countdown" >
          </mt-field>
<!--          <div class="faptcha_input">
            <input id="faptcha_response_field" name="verCode" maxlength="4" placeholder="Enter the code shown" autocorrect="off" autocapitalize="off" autocomplete="off" class="text" type="text">
          </div>
          <div class="faptcha_main">
            <div class="faptcha_image">
              <img height="48" :src="pictureCodeUrl" id="faptcha_image_img">
            </div>
            <div class="faptcha_reload" @click="changePictureCode">
              <i class="iconfont" id="faptcha_reload_btn">&#xe6ca;</i>
            </div>
          </div>-->
        </div>
      </div>

		</div>
		<mt-button type="primary" @click='addInquiry' class="ds-button-large">Submit</mt-button>
	</div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import { addInquiry, getInquiryInfo } from '../../../api/memberInquiry'
import {checkPictureCaptcha} from "@/api/common";

export default {
  data () {
    return {
      pictureCode: '',
      pictureCodeUrl: '',
      goods_id: this.$route.query.goods_id,
      subject: '',
      email: '',
      purchase_quantity: '',
      purchase_quantity_type: 'Pieces',
      content: '',
      goods_info: false
    }
  },
  components: {

  },
  mounted () {
    this.changePictureCode()
  },
  created () {
    getInquiryInfo(this.goods_id).then(res => {
      this.goods_info = res.result.goods_info
    }).catch(function (error) {
      Toast(error.message)
    })
  },
  watch: {
    pictureCode: function (val) {
      if (val.length >= 4) {
        this.pictureCodeWait = true
        checkPictureCaptcha(val).then(
            response => {
              this.pictureCodeWait = false
              this.pictureCodeValid = true
            },
            error => {
              this.pictureCodeWait = false
              Toast(error.message)
            }
        )
      }
    }
  },
  methods: {
    changePictureCode () {
      this.pictureCodeUrl = env.API_HOST + '/Seccode/makecode?r=' + Math.random()
    },
    addInquiry () {
      let router =  this.$router
      addInquiry(this.goods_id, this.subject, this.email, this.purchase_quantity, this.purchase_quantity_type, this.content, this.pictureCode).then(res => {
        Toast(res.message)
        setTimeout(function () {
          router.go(-1)
        },2500)
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    goDetail (goods_id) {
      this.$router.push({ 'name': 'HomeGoodsdetail', 'query': { 'goods_id': goods_id } })
    }
  }
}
</script>
<style lang="scss" scoped>
	.ui-common-swiper {
		width: 100%;
	}
	.ui-common-swiper-item{display: flex;align-content: center}
	.common-score-wrapper .back{display: block}
  .container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    .body {
      top: 2.2rem;
      width: 100%;
      .order-comment-body {
        background: rgba(255, 255, 255, 1);
        padding:0.75rem;
        .body-list {
          display: flex;
          justify-content: left;
          align-content: center;
          align-items: center;
          padding-bottom:0.75rem;
          border-bottom: 1px solid #e8eaed;
        }
        .image {
          width:3.7rem;
          height:3.7rem;
          flex-shrink: 0;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .comment {
          flex-basis: 100%;
          padding-left:0.75rem;
          span {
            font-size:0.8rem;
            color: #7c7f88;
            text-align: left;
            display: block;
          }
          ul {
            display: flex;
            justify-content: space-between;
            align-content: center;
            align-items: center;
            margin-top:1.2rem;
            li {
              img {
                width:1rem;
                height:1rem;
                flex-shrink: 0;
              }
              label {
                font-size:0.7rem;
                color: rgba(78, 84, 93, 1);
                font-weight: normal;
              }
            }
          }
        }
        .enter {
          padding-top:0.75rem;
          textarea {
            width: 100%;
            height: 6rem;
            background: rgba(247, 249, 250, 1);
            border: 1px solid #f7f9fa;
            box-sizing: border-box;
            padding: 0.5rem 0 0 0.5rem;
            font-size:0.7rem;
            -webkit-appearance: none;
            outline: none;
          }
        }
      }
    }
  }
	.image-wrapper{display:flex}
	.user-avatar {
		flex:1;
		border:1px solid #eee;
		position: relative;
		width: 5rem;
		height: 5rem;
		margin: 0 auto;
		text-align: center;
		img {
			width: 100%;
			height: 100%
		}
		input {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0;
			left: 0;
			opacity: 0
		}
	}
	.user-avatar::before {
		position: absolute;
		font-size: 1.5rem;
		line-height: 5rem;
		left: 50%;
		margin-left: -.75rem;
		color: rgba(0, 0, 0, 0.5)
	}
	.swipe-wrapper {
		width: 100%;
	}
	.mint-popup {
		width: 100%;
		height: 100%;
		background-color: #000;
	}
	.mint-swipe,
	.mint-swipe-items-wrap {
		position: static;
	}
	.preview-picture {
		width: 100%;
		height: 100%;
		position: fixed;
		z-index: 10;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background-color: #000;
		.picture-header {
			height:2.2rem;
			color: #000;
			background-color: #fff;
			display: flex;
			justify-content: center;
			align-content: center;
			align-items: center;
			width: 100%;
			top: 0;
			span {
				font-size:0.7rem;
				font-weight: normal;
				&:first-child {
					cursor: pointer;
					position: absolute;
					left:0.75rem;
					background-size:1.2rem;
					display: inline-block;
					height:2.2rem;
					line-height:2.2rem;
				}
			}
		}
		.picture-body {
			position: absolute;
			top:2.2rem;
			bottom: 0;
			width: 100%;
			display: flex;
			justify-content: center;
			align-content: center;
			align-items: center;
		}
	}
	.menu-item{background:#f7f9fa}
</style>
<style>
  .product_info{
    background: #fff;
    position: relative;
    padding: .5rem .75rem;
  }
  .product_info .product_info_t{
    margin-bottom: .4rem;
    font-size: .65rem;
    line-height: .9rem;
    color: #888;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .product_info .product_info_b{
    display: flex;
    align-items: center;
  }
  .product_info .product_info_b .product_info_b_dt{
    flex-shrink: 0;
    margin-left: .5rem;
  }
  .product_info .product_info_b .product_info_b_dt .product_info_b_dt_img{
    position: relative;
    width: 3rem;
    padding-top: 100%;
    border-radius: .25rem;
    overflow: hidden;
  }
  .product_info .product_info_b .product_info_b_dt .product_info_b_dt_img img{
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    max-width: 100%;
    max-height: 100%;
  }
  .product_info .product_info_b .product_info_b_dd{
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .product_info .product_info_b .product_info_b_dd .product_info_name{
    font-size: .7rem;
    line-height: .975rem;
    color: #222;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .product_info .product_info_b .product_info_b_dd .product_info_price{
    margin-top: .1rem;
    font-size: .65rem;
    line-height: .9rem;
    color: #888;
  }
  .inquiry_info{
    margin-top: .4rem;
    padding: .75rem;
    background: #fff;
    position: relative;
  }
  .inquiry_info .inquiry_info_title{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .inquiry_info .inquiry_info_title h3{
    font-size: .8rem;
    font-weight: bold;
    line-height: 1.05rem;
    color: #222;
  }
  .inquiry_info .inquiry_info_desc{
    position: relative;
    display: inline-block;
    width: 100%;
    background: #fff;
    margin-top: .5rem;
  }
  .inquiry_info .inquiry_info_desc .input_textarea{
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    resize: none;
    border: 0;
    border-bottom: 0;
    overflow: auto;
    vertical-align: top;
    color: #222;
    font-size: 14px;
    line-height: 17px;
    outline: 0;
    -webkit-appearance: none;
    border-radius: 0;
    padding: 15px;
    background: #f6f6f6;
    border-top-left-radius: .25rem;
    border-top-right-radius: .25rem;
  }
  .contact_info{
    margin-top: .4rem;
    padding: .75rem;
    background: #fff;
    position: relative;
  }
  .contact_info .contact_info_title{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .contact_info .contact_info_title h3{
    font-size: .8rem;
    font-weight: bold;
    line-height: 1.05rem;
    color: #222;
  }
  .contact_info .contact_info_form{
    overflow: hidden;
  }
  .contact_info .contact_info_form .contact_info_form_item{
    border-bottom: 1px solid #d9d9d9;
    position: relative;
  }
  .contact_info .contact_info_form .contact_info_form_item .input_text{
    width: 100%;
    height: 48px;
    border: none;
    outline: 0;
    color: #222;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
  }
  .contact_info .contact_info_form .contact_info_form_item .input_text::-webkit-input-placeholder{
    color: #999;
  }
  .contact_info .contact_info_form .contact_info_form_item .input_text.purchase_quantity{
    padding-left: 120px;
    box-sizing:border-box;
  }
  .contact_info .contact_info_form .contact_info_form_item .input_select{
    display: block;
    width: 110px;
    height: 30px;
    background-color: #ffffff;
    border: 1px solid #cccccc;
    padding: 2px 5px 2px 2px;
    position: absolute;
    left: 0;
    top: 9px;
  }
  .verification_info{
    margin-top: .4rem;
    padding: .75rem;
    background: #fff;
    position: relative;
  }
  .verification_info .verification_info_title{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .verification_info .verification_info_title h3{
    font-size: .8rem;
    font-weight: bold;
    line-height: 1.05rem;
    color: #222;
  }
  .verification_info .verification_info_con{
    margin-top: .5rem;
  }
  .verification_info .verification_info_con .faptcha_input{
    float: right;
    width: 7.15rem;
  }
  .verification_info .verification_info_con .faptcha_input #faptcha_response_field{
    padding: 0 .25rem;
    width: 100%;
    height: 2rem;
    border: 1px solid #dae0e5;
    line-height: 2rem;
    box-sizing: border-box;
  }
  .verification_info .verification_info_con .faptcha_main{}
  .verification_info .verification_info_con .faptcha_main .faptcha_image{
    width: 5.6rem;
    line-height: 2rem;
    height: 2rem;
    display: inline-block;
    overflow: hidden;
  }
  .verification_info .verification_info_con .faptcha_main .faptcha_image #faptcha_image_img{
    width: 5.6rem;
    height: 2rem;
  }
  .verification_info .verification_info_con .faptcha_main .faptcha_reload{
    display: inline-block;
    height: 2rem;
    line-height: 2rem;
    vertical-align: top;
    padding-left: .5rem;
  }
  .verification_info .verification_info_con .faptcha_main .faptcha_reload #faptcha_reload_btn{
    width: .95rem;
    font-family: "Mic-icon";
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    vertical-align: baseline;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #e64545;
    height: 2rem;
    line-height: 2rem;
  }
</style>